export default __webpack_public_path__ + "images/31a9ed367f7ed05d915f0c0ba78149db-foot-left.svg";